// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1206":"033e41b88c498627","3870":"79d0d09416f3b7cd","6731":"99d854535bc969a1","8235":"1f969f6ba72a2c19","8342":"5e52b8f144426514","9954":"e798c822fce3f88a"}[chunkId] + ".css";
};